export const ORDER_STATUS = {
  NEW: "NEW",
  CANCELLED: "CANCELLED",
  ONGOING: "ONGOING",
  FORPICKUP: "FOR_PICKUP",
  DELIVERED: "DELIVERED"
};
